export default "__VITE_ASSET__D_bkf_Cx__"